import { render, staticRenderFns } from "./TheGridBanner.vue?vue&type=template&id=5ad40f56&"
import script from "./TheGridBanner.vue?vue&type=script&lang=js&"
export * from "./TheGridBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad40f56')) {
      api.createRecord('5ad40f56', component.options)
    } else {
      api.reload('5ad40f56', component.options)
    }
    module.hot.accept("./TheGridBanner.vue?vue&type=template&id=5ad40f56&", function () {
      api.rerender('5ad40f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheGridBanner.vue"
export default component.exports